import app from 'flarum/app';

import {extend} from 'flarum/extend';
import {override} from 'flarum/extend';

import Button from 'flarum/components/Button';
import LogInButtons from 'flarum/components/LogInButtons';
import LogInModal from 'flarum/components/LogInModal';

export default function () {
  extend(LogInModal.prototype, 'showLogin', function () {
    $('#showLoginFormButton').hide();
    $('.Form').removeClass('Form--hidden');
  });

  override(LogInModal.prototype, 'body', function () {
    return [
      <LogInButtons/>,

      <div class="LogInButtons">
        <Button
          className="Button LogInButton LogInButton--secondary"
          id="showLoginFormButton"
          onclick={this.showLogin}
          type="button">
          {app.translator.trans('rajce_update.forum.log_in.moderators')}
        </Button>
      </div>,

      <div className="Form Form--centered Form--hidden">
        {this.fields().toArray()}
      </div>
    ];
  });
}
